import { EventDispatcher } from "./EventDispatcher.js";

export class Xiangji extends EventDispatcher {
  constructor(args) {
    super()
    // 必须在 imgdata 早退之前初始化：早退实例的 destory() 也要能安全遍历
    this._domListeners = []
    this._disposed = false

    this.imgdata = args.data.data || null
    this.pointInfo = args.data.pointData || null
    this.domWrap = args.dom
    this.emptyImg = args.data.emptyImg || ''
    if (!this.imgdata) return

    this.domElement = this.loadHTML()

    // 收缩按钮
    let contraction = this.domElement.find('.contraction')
    this.contraction = contraction[0]
    this._bindDom(this.contraction, 'click', this.contractionHandler.bind(this))
    this.isExpand = true

    //   左右移动滚动条
    let xiangjiwrap = this.domElement.find('.xiangjiwrap')
    this.xiangjiwrap = xiangjiwrap[0]
    let operationBtn_left = this.domElement.find('.operationBtn.btn_left')
    let operationBtn_right = this.domElement.find('.operationBtn.btn_right')
    this.operationBtn_left = operationBtn_left[0]
    this.operationBtn_right = operationBtn_right[0]

    if (this.imgdata.length > 3) {
      this.operationBtn_left.style.display = 'block'
      this.operationBtn_right.style.display = 'block'

      this._bindDom(this.operationBtn_left, 'click', this.btnHandler.bind(this, 'left'))
      this._bindDom(this.operationBtn_right, 'click', this.btnHandler.bind(this, 'right'))
    } else {
      this.operationBtn_left.style.display = 'none'
      this.operationBtn_right.style.display = 'none'
    }

    // 点击图片放大
    this.pointImgs = this.domElement.find('.aacontent')
    for (let index = 0; index < this.pointImgs.length; index++) {
      this._bindDom(
        this.pointImgs[index],
        'click',
        this.imgClickHandler.bind(this, this.imgdata[index])
      )
    }

    // 导出excel
    let exportBtn = this.domElement.find('.exportBtn')
    this.exportBtn = exportBtn[0]
    this._bindDom(this.exportBtn, 'click', this.exportEXCEL.bind(this))

    // 挂载与卸载都由 Xiangji 自己拥有：卸载在 destory() 内，挂载必须也在这里，
    // 否则 destory() 就是在赌一个自己没建立的父子关系（本次缺陷的土壤）。
    // 不传 dom 的调用方仍可自行挂载，destory() 已对 parentNode 判空。
    if (this.domWrap) {
      this.domWrap.append(this.domElement)
    }

    this.pzBtn = this.domElement.find('.cxpzan')
    this.anyResStatus = this.domElement.find('.anyResStatus')

    for (let index = 0; index < this.pzBtn.length; index++) {
      let element = this.pzBtn[index]
      let d = element.getAttribute('xjdata')
      let popo = this.imgdata.filter((item) => item.id == d)
      this._bindDom(element, 'click', this.pzBtnClick.bind(this, popo[0] || null, this.pointInfo))
    }
    for (let index = 0; index < this.anyResStatus.length; index++) {
      let element = this.anyResStatus[index]
      let d = element.getAttribute('xjdata')
      let popo = this.imgdata.filter((item) => item.id == d)
      this._bindDom(element, 'click', this.statusClick.bind(this, popo[0] || null, this.pointInfo))
    }
  }

  // 统一登记 DOM 监听，供 destory() 精确解绑。
  // 直接在 addEventListener 里写 .bind() 会每次生成新函数对象，
  // removeEventListener 拿不到同一引用，解绑必然失效（本文件原先 4 处均如此）。
  _bindDom(el, type, fn) {
    if (!el) return
    el.addEventListener(type, fn)
    this._domListeners.push({ el, type, fn })
  }

  // destory 之后误用的告警。只警告一次：避免业务侧循环刷新数据时刷爆控制台，
  // 掩盖真正的首次现场。恒返回 undefined，便于调用方 `return this._warnDisposed(...)`。
  _warnDisposed(where) {
    if (this._disposedWarned) return
    this._disposedWarned = true
    console.warn(`[Xiangji] ${where}: 相册已 destory，本次调用被忽略。` +
      `请在 showPointImg(true) 重新展开后再更新数据。`)
  }

  pzBtnClick(e, pointInfo) {
    this.dispatchEvent({
      type: 'pzBtnClick',
      data: e,
      pointInfo: pointInfo
    })
  }

  statusClick(e, pointInfo) {
    this.dispatchEvent({
      type: 'statusClick',
      data: e,
      pointInfo: pointInfo
    })
  }

  updataImg(data) {
    if (this._disposed || !this.domElement) return this._warnDisposed('updataImg')
    let pointImg = this.domElement.find('.pointImg')
    for (let index = 0; index < pointImg.length; index++) {
      let element = pointImg[index]
      let d = element.getAttribute('xjdata')
      if (data.id == d) {
        element.src = data.filePath
      }
    }

    this.imgdata.forEach((item) => {
      if (item.id == data.id) {
        item.filePath = data.filePath
      }
    })
  }

  updateStatus(data) {
    if (this._disposed || !this.domElement) return this._warnDisposed('updateStatus')
    let anyResStatus = this.domElement.find('.anyResStatus')
    for (let index = 0; index < anyResStatus.length; index++) {
      let element = anyResStatus[index]
      let d = element.getAttribute('xjdata')
      if (data.id == d) {
        element.innerHTML = data.valid == 1 ? '<svg t="1767164127206" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4133" width="15" height="15"><path d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 81.749333a430.250667 430.250667 0 1 0 0 860.501334A430.250667 430.250667 0 0 0 512 81.749333z m307.285333 271.189334a40.96 40.96 0 0 1 0.768 57.856l-0.768 0.682666-328.96 329.045334a40.96 40.96 0 0 1-57.856 0L267.946667 576a40.96 40.96 0 0 1-5.205334-51.370667l5.205334-6.485333a40.96 40.96 0 0 1 57.856 0l135.594666 135.68 300.117334-300.117333a40.96 40.96 0 0 1 57.770666-0.768z" p-id="4134" fill="#32CD32"></path></svg>'
          : '<svg t="1767164162047" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14809" width="15" height="15"><path d="M512 64c247.296 0 448 200.704 448 448s-200.704 448-448 448-448-200.704-448-448S264.704 64 512 64M512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z" fill="#c62f2f" p-id="14810"></path><path d="M715.776 671.232l-158.72-159.232 159.232-159.232c11.264-13.312 9.728-33.792-3.584-45.056-12.288-10.24-29.696-10.24-41.472 0.512l-158.72 158.72-158.72-157.696c-12.8-12.8-32.768-12.8-45.568 0s-12.8 32.768 0 45.568L465.92 512l-157.184 157.696c-12.8 12.8-12.8 32.768 0 45.568s32.768 12.8 45.568 0l158.208-157.696 159.232 159.232c12.288 12.288 32.256 12.288 45.056 0 12.288-12.288 12.288-32.256 0-45.056l-1.024-0.512z" fill="#c62f2f" p-id="14811"></path></svg>'
      }
    }
    this.imgdata.forEach((item) => {
      if (item.id == data.id) {
        item.valid = data.valid
      }
    })
  }

  exportEXCEL() {
    this.dispatchEvent({
      type: 'exportEXCEL',
      data: { pointData: this.pointInfo, data: this.imgdata }
    })
  }

  // 幂等：业务侧「先 showPointImg(false) 收起、再 annotations.remove() 移除」是正常时序，
  // 两条路径都会走到这里（AnnotationYd2.js 的 showPointImg(false) 与 dispose()），
  // 所以第二次调用不是误用，不告警、直接早退。
  destory() {
    if (this._disposed) return
    this._disposed = true

    for (const { el, type, fn } of this._domListeners) {
      el.removeEventListener(type, fn)
    }
    this._domListeners.length = 0

    const el = this.domElement && this.domElement[0]
    if (el && el.parentNode) {
      el.parentNode.removeChild(el)
    }
    this.domElement = null
    // 切断业务回调（clickImage / pzBtnClick / statusClick / exportEXCEL）对已死实例的强引用
    this._listeners = {}
  }
  imgClickHandler(data) {
    this.dispatchEvent({ type: 'clickImage', data })
  }
  btnHandler(type) {
    let scrollLeft = this.xiangjiwrap.scrollLeft
    if (type == 'left') {
      scrollLeft -= 600
    }
    if (type == 'right') {
      scrollLeft += 600
    }

    this.xiangjiwrap.scrollTo({
      left: scrollLeft,
      behavior: 'smooth' // 平滑滚动效果
    })
  }
  contractionHandler(e) {
    // 纯兜底：destory 已真正解绑该监听并摘除节点，正常不会再触发。事件回调不告警。
    if (!this.domElement) return
    this.isExpand = !this.isExpand

    if (!this.isExpand) {
      this.domElement[0].style.width = 0
      this.domElement[0].style.borderWidth = '0'
    } else {
      this.domElement[0].style.borderWidth = '1px'
      this.domElement[0].style.width = '580px'
    }
  }
  loadImg(data) {
    return `<div class="xiangjiaa">
            <div class="aatop">
              <svg
             
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                fill="none"
                version="1.1"
                width="19.1572265625"
                height="20.94580078125"
                viewBox="0 0 19.1572265625 20.94580078125"
              >
                <defs>
                  <filter
                    id="master_svg0_779_06179"
                    filterUnits="objectBoundingBox"
                    color-interpolation-filters="sRGB"
                    x="-8"
                    y="-8"
                    width="23.15727472305298"
                    height="24.945656776428223"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
                  </filter>
                  <linearGradient x1="0.5" y1="0" x2="0.5" y2="1" id="master_svg1_208_5210">
                    <stop offset="0%" stop-color="#5DE2FF" stop-opacity="1" />
                    <stop offset="0.009999999747378752%" stop-color="#40E5F0" stop-opacity="1" />
                    <stop offset="100%" stop-color="#648AFD" stop-opacity="1" />
                  </linearGradient>
                </defs>
                <g>
                  <g style="opacity: 0.4000000059604645" filter="url(#master_svg0_779_06179)">
                    <path
                      d="M8.77054,10.23742L6,6L13.15727,10.23742L6,14.94566L8.77054,10.23742Z"
                      fill="#32FFE6"
                      fill-opacity="1"
                    />
                  </g>
                  <g>
                    <path
                      d="M8.77054,10.23742L6,6L13.15727,10.23742L6,14.94566L8.77054,10.23742Z"
                      fill="url(#master_svg1_208_5210)"
                      fill-opacity="1"
                    />
                  </g>
                </g>
              </svg>
              <span>${(data.productBrand || '') + (data.productModel || '')}</span>
            </div>
            <div class="aacontent">
              <img xjdata="${data.id}" class="pointImg" src="${data.filePath}" alt="" />
            </div>
            <div style="${data && data.id ? 'display:block' : 'display:none'}" class="cxpzan" xjdata="${data.id}">
              <svg t="1725624757919" class="icon" viewBox="0 0 1346 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="60063" width="15" height="15"><path d="M996.251775 162.76202h-646.736502l107.789417-159.258864L856.66448 0l139.587295 162.76202zM118.845921 70.063121h136.084139v54.703129H118.845921z" p-id="60064" fill="#ffffff"></path><path d="M1274.34847 161.684125H71.418577A71.410489 71.410489 0 0 0 0.008088 234.172508v718.146991A71.410489 71.410489 0 0 0 71.418577 1023.999461h1202.929893a71.141015 71.141015 0 0 0 71.410489-71.141015V234.172508A71.410489 71.410489 0 0 0 1274.34847 161.684125zM673.691944 913.245835A320.134568 320.134568 0 1 1 993.018092 592.841793 319.865095 319.865095 0 0 1 673.691944 913.245835zM1075.207523 379.957695a41.229452 41.229452 0 1 1 41.229452-41.229452 40.959978 40.959978 0 0 1-41.229452 41.229452z" p-id="60065" fill="#ffffff"></path><path d="M672.883524 593.111267m-242.526188 0a242.526188 242.526188 0 1 0 485.052376 0 242.526188 242.526188 0 1 0-485.052376 0Z" p-id="60066" fill="#ffffff"></path></svg>
            </div>
            <div style="${data && data.id ? 'display:block' : 'display:none'}" class="anyResStatus" xjdata="${data.id}">
                      ${data.valid == 1 ? '<svg t="1767164127206" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4133" width="15" height="15"><path d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 81.749333a430.250667 430.250667 0 1 0 0 860.501334A430.250667 430.250667 0 0 0 512 81.749333z m307.285333 271.189334a40.96 40.96 0 0 1 0.768 57.856l-0.768 0.682666-328.96 329.045334a40.96 40.96 0 0 1-57.856 0L267.946667 576a40.96 40.96 0 0 1-5.205334-51.370667l5.205334-6.485333a40.96 40.96 0 0 1 57.856 0l135.594666 135.68 300.117334-300.117333a40.96 40.96 0 0 1 57.770666-0.768z" p-id="4134" fill="#32CD32"></path></svg>'
        : '<svg t="1767164162047" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14809" width="15" height="15"><path d="M512 64c247.296 0 448 200.704 448 448s-200.704 448-448 448-448-200.704-448-448S264.704 64 512 64M512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z" fill="#c62f2f" p-id="14810"></path><path d="M715.776 671.232l-158.72-159.232 159.232-159.232c11.264-13.312 9.728-33.792-3.584-45.056-12.288-10.24-29.696-10.24-41.472 0.512l-158.72 158.72-158.72-157.696c-12.8-12.8-32.768-12.8-45.568 0s-12.8 32.768 0 45.568L465.92 512l-157.184 157.696c-12.8 12.8-12.8 32.768 0 45.568s32.768 12.8 45.568 0l158.208-157.696 159.232 159.232c12.288 12.288 32.256 12.288 45.056 0 12.288-12.288 12.288-32.256 0-45.056l-1.024-0.512z" fill="#c62f2f" p-id="14811"></path></svg>'
      }
            </div>
          </div>`
  }
  loadHTML() {
    let str = ''
    let imgList = this.imgdata.map((item) => item)
    // let idx = 3 - imgList.length
    // if (idx > 0) {
    //   for (let index = 0; index < idx; index++) {
    //     imgList.push({ filePath: this.emptyImg })
    //   }
    // }
    imgList.forEach((item) => {
      str += this.loadImg(item)
    })

    return $(`<div class="cameraDialog ${imgList.length == 1 ? 'single' : imgList.length == 2 ? 'double' : ''}">
      <div>
        <div class="diatop">
          <svg
           class="contraction"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="13.34000015258789"
            height="11.466666221618652"
            viewBox="0 0 13.34000015258789 11.466666221618652"
          >
            <g>
              <path
                d="M0.173333,5.36C-0.0466667,5.53333,-0.0466667,5.88667,0.173333,6.10667C0.173333,6.10667,2.76,7.91333,2.76,7.91333C3.07333,8.13333,3.47333,7.91333,3.47333,7.56C3.47333,7.56,3.47333,3.90667,3.47333,3.90667C3.47333,3.81333,3.44,3.72,3.38667,3.64C3.24,3.44667,2.96,3.40667,2.76,3.55333C2.76,3.55333,0.173333,5.36,0.173333,5.36C0.173333,5.36,0.173333,5.36,0.173333,5.36ZM0,0.533333C0,0.826667,0.24,1.06667,0.533333,1.06667C0.533333,1.06667,12.8,1.06667,12.8,1.06667C13.0933,1.06667,13.3333,0.826667,13.3333,0.533333C13.3333,0.24,13.0933,0,12.8,0C12.8,0,0.533333,0,0.533333,0C0.24,0,0,0.24,0,0.533333C0,0.533333,0,0.533333,0,0.533333ZM0,10.9333C0,11.2267,0.24,11.4667,0.533333,11.4667C0.533333,11.4667,12.8,11.4667,12.8,11.4667C13.0933,11.4667,13.3333,11.2267,13.3333,10.9333C13.3333,10.64,13.0933,10.4,12.8,10.4C12.8,10.4,0.533333,10.4,0.533333,10.4C0.24,10.4,0,10.64,0,10.9333C0,10.9333,0,10.9333,0,10.9333ZM4.53333,4C4.53333,4.29333,4.77333,4.53333,5.06667,4.53333C5.06667,4.53333,12.8,4.53333,12.8,4.53333C13.0933,4.53333,13.3333,4.29333,13.3333,4C13.3333,3.70667,13.0933,3.46667,12.8,3.46667C12.8,3.46667,5.06667,3.46667,5.06667,3.46667C4.77333,3.46667,4.53333,3.70667,4.53333,4C4.53333,4,4.53333,4,4.53333,4ZM4.53333,7.47333C4.53333,7.76,4.77333,8,5.06667,8C5.06667,8,12.8067,8,12.8067,8C13.1,8,13.34,7.76,13.34,7.46667C13.34,7.17333,13.1,6.93333,12.8067,6.93333C12.8067,6.93333,5.06667,6.93333,5.06667,6.93333C4.77333,6.93333,4.53333,7.17333,4.53333,7.46667C4.53333,7.46667,4.53333,7.47333,4.53333,7.47333C4.53333,7.47333,4.53333,7.47333,4.53333,7.47333Z"
                fill="#FFFFFF"
                fill-opacity="1"
              />
            </g>
          </svg>
          <svg
            class="exportBtn"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <defs>
              <clipPath id="master_svg0_779_06196">
                <rect x="0" y="0" width="16" height="16" rx="0" />
              </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_779_06196)">
              <g>
                <path
                  d="M7.181198671875,8.0578364140625C7.181198671875,7.5390864140625,6.760888671875,7.1187744140625,6.242138671875,7.1187744140625C5.723388671875,7.1187744140625,5.301513671875,7.5390864140625,5.301513671875,8.0578364140625C5.301513671875,8.5765844140625,5.721825671875,8.9968944140625,6.242138671875,8.9968944140625C6.759328671875,8.9984644140625,7.181198671875,8.5781544140625,7.181198671875,8.0578364140625ZM9.143698671875,12.1265844140625C9.389018671875,10.5922144140625,10.624948671875,9.3906444140625,12.174948671875,9.1968944140625L12.018698671875,8.6890844140625L11.224948671875,8.9531444140625L10.535888671875,7.6562744140625L8.312448671875,10.8656444140625L7.121828671875,10.0968944140625L5.254638671875,12.1265844140625L9.143698671875,12.1265844140625Z"
                  fill="#FFFFFF"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M4.057814140625,12.9531810546875L4.057814140625,6.2187710546875C4.057814140625,6.0984610546875,4.154684140625,6.0015810546875,4.274994140625,6.0015810546875L13.760944140625,6.0015810546875C13.881244140625,6.0015810546875,13.978144140625,6.0984610546875,13.978144140625,6.2187710546875L13.978144140625,9.443771054687499C14.345344140625,9.5984610546875,14.679644140625,9.8125210546875,14.971844140625,10.0750210546875L14.971844140625,5.4984610546875C14.971844140625,5.2265810546875,14.751544140625,5.0078310546875,14.481244140625,5.0078310546875L12.387544140625,5.0078310546875L11.148444140625,1.7859590546875C11.051544140625,1.5328337546875,10.767144140625,1.4062712546875,10.514044140625,1.5031462546875L0.315622140625,5.4234610546875C0.062496840625,5.5219010546875,-0.064065659375,5.8062710546875,0.032809340625,6.0594010546875L3.064064140625,13.9421810546875L3.064064140625,13.9468810546875L9.332814140625,13.9468810546875C9.212494140625,13.6343810546875,9.135934140625,13.3015810546875,9.109374140625,12.9531810546875L4.057814140625,12.9531810546875ZM10.318744140625,2.6406510546875C10.351544140625,2.6359610546875,10.404644140625,2.6375210546875003,10.432844140625,2.7000210546875003L11.320344140625,5.006271054687501L4.165624140625,5.006271054687501L10.318744140625,2.6406510546875ZM3.064064140625,11.1734610546875L1.217184140625,6.3734610546875C1.174994140625,6.2625210546875,1.229684140625,6.1359610546875,1.342184140625,6.0937710546875L3.064064140625,5.4312710546875L3.064064140625,11.1734610546875Z"
                  fill="#FFFFFF"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M15.976508671875,12.5000082421875L13.609328671875,10.6015698421875C13.573388671875,10.5750073421875,13.523388671875,10.6000073221875,13.523388671875,10.6453198421875L13.523388671875,11.8187582421875L10.468700671875,11.8187582421875C10.385888671875,11.8187582421875,10.317138671875,11.8859482421875,10.317138671875,11.9687582421875L10.317138671875,13.1515682421875C10.317138671875,13.2343782421875,10.384326171875,13.3031282421875,10.468700671875,13.3031282421875L13.523388671875,13.3031282421875L13.523388671875,14.4765682421875C13.523388671875,14.5203182421875,13.574948671875,14.5468782421875,13.609328671875,14.5203182421875L15.976508671875,12.621878242187499C16.017138671875,12.590628242187499,16.017138671875,12.5296982421875,15.976508671875,12.5000082421875Z"
                  fill="#FFFFFF"
                  fill-opacity="1"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="diacontent">
          <div class="operationBtn btn_left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="none"
              version="1.1"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g>
                <path
                  d="M10,0C15.52,0,20,4.48,20,10C20,15.52,15.52,20,10,20C4.48,20,0,15.52,0,10C0,4.48,4.48,0,10,0ZM10,9L10,6L6,10L10,14L10,11L14,11L14,9L10,9Z"
                  fill="#FFFFFF"
                  fill-opacity="1"
                />
              </g>
            </svg>
          </div>
          <div class="operationBtn btn_right">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="none"
              version="1.1"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g transform="matrix(-1,0,0,-1,40,40)">
                <path
                  d="M30,20C35.519999999999996,20,40,24.48,40,30C40,35.519999999999996,35.519999999999996,40,30,40C24.48,40,20,35.519999999999996,20,30C20,24.48,24.48,20,30,20ZM30,29L30,26L26,30L30,34L30,31L34,31L34,29L30,29Z"
                  fill="#FFFFFF"
                  fill-opacity="1"
                />
              </g>
            </svg>
          </div>
          <div class="xiangjiwrap">
          ${str}
          </div>
        </div>
      </div>
    </div>`)
  }
  shuchu() {
    //
  }
}